import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=7b221508&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=7b221508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b221508",
  null
  
)

export default component.exports